import axios from 'axios'

export default {
  async getProcesses () {
    try {
      const response = await axios.get('/admin/cloning')
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async createProcess (data) {
    try {
      const response = await axios.post('/admin/cloning', data)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  // async connect (process) {
  //   try {
  //     const response = await axios.post(`/admin/cloning/${process}/connect`)
  //     return _.get(response, 'data.data')
  //   } catch (err) {
  //     console.error(err)
  //     return _.get(err, 'response.data', false)
  //   }
  // },
  async getAvailableContent (process) {
    try {
      const response = await axios.get(`/admin/cloning/${process}/available`)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async saveManifest (process, manifest) {
    try {
      const response = await axios.post(`/admin/cloning/${process}/manifest`, { manifest })
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async savePreferences (process, preferences) {
    try {
      const response = await axios.post(`/admin/cloning/${process}/preferences`, { preferences })
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async sendPayload (process, force = false) {
    try {
      const response = await axios.post(`/admin/cloning/${process}/send-payload`, { force })
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async start (process, force = false) {
    try {
      const response = await axios.post(`/admin/cloning/${process}/start`, { force })
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async cancel (process) {
    try {
      const response = await axios.post(`/admin/cloning/${process}/cancel`)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async remove (process) {
    try {
      const response = await axios.delete(`/admin/cloning/${process}`)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  }
}